import { render, staticRenderFns } from "./tiki.vue?vue&type=template&id=db2a0a78&scoped=true"
import script from "./tiki.vue?vue&type=script&lang=js"
export * from "./tiki.vue?vue&type=script&lang=js"
import style0 from "./tiki.vue?vue&type=style&index=0&id=db2a0a78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db2a0a78",
  null
  
)

export default component.exports